export const calendarIcons = {
  plusCircle: 'assets/img/icon/plus-circle-dotted.svg',
  checkCircle: 'assets/img/icon/mark-circle.svg'
};
